import { ChangeDetectionStrategy, Component, input, OnInit } from "@angular/core";

@Component({
    selector: 'app-points-progress-bar',
    templateUrl: './points-progress-bar.component.html',
    styleUrls: ['./points-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PointsProgressBarComponent implements OnInit {
    necessaryPoints = input.required<number>();
    currentPoints = input.required<number>();

    constructor() {}

    ngOnInit(): void {}

    getProgressPercent(): number {
        const percentage = Math.round((this.currentPoints() / this.necessaryPoints()) * 100);
        if (percentage > 100) return 100;
        return percentage;
    }
}
